import qs from 'qs';
import client from './client';

const staticsConfUrl = '/api/v1/statistics/config';
const staticsExpect = '/api/v1/statistics/target/expect';
const staticsInvoice = '/api/v1/statistics/invoice';
const staticsSales = '/api/v1/statistics/sales';
const staticsProject = '/api/v1/statistics/forecast';

//user별 설정데이터 가져오기
export const getStatConfByUser = (searchData) => {
  const queryString = qs.stringify(searchData);
  return client.get(`${staticsConfUrl}/conf/info?${queryString}`);
};

//User 영업 목표 정보 저장
export const addStaticsConf = (dataToSubmit) => {
  return client.post(`${staticsConfUrl}/conf/info`, dataToSubmit);
};

//company 정보 가져오기
export const getCompanyStatics = (year, checkedList) => {
  //const queryString = qs.stringify(searchData);
  let url = `${staticsConfUrl}/result/company/${year}`;
  if (checkedList !== null && checkedList !== '') {
    url = url + `?prjImpts=${checkedList}`;
  }
  return client.get(url);
};

//본부 정보 가져오기
export const getHqStatics = (year, checkedList) => {
  let url = `${staticsConfUrl}/result/headQuarter/${year}`;
  if (checkedList !== null && checkedList !== '') {
    url = url + `?prjImpts=${checkedList}`;
  }
  return client.get(url);
};

//부서
export const getDpStatics = (year, checkedList) => {
  let url = `${staticsConfUrl}/result/depart/${year}`;
  if (checkedList !== null && checkedList !== '') {
    url = url + `?prjImpts=${checkedList}`;
  }
  return client.get(url);
};

//사원
export const getEmpStatics = (year, checkedList) => {
  let url = `${staticsConfUrl}/result/employee/${year}`;
  if (checkedList !== null && checkedList !== '') {
    url = url + `?prjImpts=${checkedList}`;
  }
  return client.get(url);
};

//제조사
export const getManuStatics = (year, checkedList) => {
  let url = `${staticsConfUrl}/result/vendor/${year}`;
  if (checkedList !== null && checkedList !== '') {
    url = url + `?prjImpts=${checkedList}`;
  }
  return client.get(url);
};

//매출처
export const getVendorStatics = (year, checkedList) => {
  let url = `${staticsConfUrl}/result/iocome/sales/${year}`;
  if (checkedList !== null && checkedList !== '') {
    url = url + `?prjImpts=${checkedList}`;
  }
  return client.get(url);
};

//매입처
export const getPurchaseStatics = (year, checkedList) => {
  let url = `${staticsConfUrl}/result/iocome/buy/${year}`;
  if (checkedList !== null && checkedList !== '') {
    url = url + `?prjImpts=${checkedList}`;
  }
  return client.get(url);
};

//목표등록통계
export const getHqExpectStatics = (year, strMonth, endMonth, selectedGbn) => {
  let url = `${staticsExpect}/headQuarter/${selectedGbn}/${year}/${strMonth}/${endMonth}`;
  return client.get(url);
};

export const getDepartExpectStatics = (
  year,
  strMonth,
  endMonth,
  selectedGbn,
) => {
  let url = `${staticsExpect}/depart/${selectedGbn}/${year}/${strMonth}/${endMonth}`;
  return client.get(url);
};

export const getEmpExpectStatics = (year, strMonth, endMonth, selectedGbn) => {
  let url = `${staticsExpect}/employee/${selectedGbn}/${year}/${strMonth}/${endMonth}`;
  return client.get(url);
};

//세금계산서 통계(본부)
export const getHqTaxbillStatics = (
  year,
  strMonth,
  endMonth,
  selectedGbn,
  selectPrjTyp,
) => {
  const url = `${staticsInvoice}/headQuarter/${selectPrjTyp}/${selectedGbn}/${year}/${strMonth}/${endMonth}`;
  return client.get(url);
};

//세금계산서 통계(팀)
export const getTeamTaxbillStatics = (
  year,
  strMonth,
  endMonth,
  selectedGbn,
  selectPrjTyp,
) => {
  const url = `${staticsInvoice}/depart/${selectPrjTyp}/${selectedGbn}/${year}/${strMonth}/${endMonth}`;
  return client.get(url);
};

//세금계산서 통계(팀원)
export const getEmpTaxbillStatics = (
  year,
  strMonth,
  endMonth,
  selectedGbn,
  selectPrjTyp,
) => {
  const url = `${staticsInvoice}/employee/${selectPrjTyp}/${selectedGbn}/${year}/${strMonth}/${endMonth}`;
  return client.get(url);
};

//채권/채무 통계
export const getHqBondsDeptsStatics = (
  year,
  strMonth,
  endMonth,
  selectedGbn,
  selectPrjTyp,
  searchData,
) => {
  const queryString = qs.stringify(searchData);
  const url = `${staticsInvoice}/headQuarter/${selectPrjTyp}/${selectedGbn}/${year}/${strMonth}/${endMonth}?${queryString}`;
  return client.get(url);
};

export const getTeamBondsDeptsStatics = (
  year,
  strMonth,
  endMonth,
  selectedGbn,
  selectPrjTyp,
  searchData,
) => {
  const queryString = qs.stringify(searchData);
  const url = `${staticsInvoice}/depart/${selectPrjTyp}/${selectedGbn}/${year}/${strMonth}/${endMonth}?${queryString}`;
  return client.get(url);
};

export const getEmpBondsDeptsStatics = (
  year,
  strMonth,
  endMonth,
  selectedGbn,
  selectPrjTyp,
  searchData,
) => {
  const queryString = qs.stringify(searchData);
  const url = `${staticsInvoice}/employee/${selectPrjTyp}/${selectedGbn}/${year}/${strMonth}/${endMonth}?${queryString}`;
  return client.get(url);
};

export const getEmployeeBondsDeptsStatics = (
  year,
  strMonth,
  endMonth,
  selectedGbn,
  searchData,
) => {
  const queryString = qs.stringify(searchData);
  const url = `${staticsInvoice}/employee/${selectedGbn}/${year}/${strMonth}/${endMonth}?${queryString}`;
  return client.get(url);
};

// 영업 통계
export const getHqSalesStatics = (year, strMonth, endMonth) => {
  const url = `${staticsSales}/headQuarter/${year}/${strMonth}/${endMonth}`;
  return client.get(url);
};

export const getDepartSalesStatics = (year, strMonth, endMonth) => {
  const url = `${staticsSales}/depart/${year}/${strMonth}/${endMonth}`;
  return client.get(url);
};

export const getEmpSalesStatics = (year, strMonth, endMonth) => {
  const url = `${staticsSales}/employee/${year}/${strMonth}/${endMonth}`;
  return client.get(url);
};

//수주통계 - 본부
export const getOrderStaticsByHeadquarter = (selectPrjTyp, searchData) => {
  const queryString = qs.stringify(searchData);
  const url = `${staticsProject}/headquarter/${selectPrjTyp}?${queryString}`;
  return client.get(url);
};

export const getOrderStaticsByDepart = (selectPrjTyp, searchData) => {
  const queryString = qs.stringify(searchData);
  const url = `${staticsProject}/depart/${selectPrjTyp}?${queryString}`;
  console.log(url);
  return client.get(url);
};

export const getOrderStaticsByEmp = (selectPrjTyp, searchData) => {
  const queryString = qs.stringify(searchData);
  const url = `${staticsProject}/employee/${selectPrjTyp}?${queryString}`;
  return client.get(url);
};
